import * as API from '../api'
export const FETCH_NAME_DCB = 'FETCH_NAME_DCB'
export const FETCHING_NAME_DCB = 'FETCHING_NAME_DCB'
export const FETCH_NAME_DCB_ERROR = 'FETCH_NAME_DCB_ERROR'
export const FETCH_NAMES_DCB = 'FETCH_NAMES_DCB'
export const FETCHING_NAMES_DCB = 'FETCHING_NAMES_DCB'
export const FETCH_NAMES_DCB_ERROR = 'FETCH_NAMES_DCB_ERROR'
export const FETCH_ATCCLASSIFICATION = 'FETCH_ATCCLASSIFICATION'
export const OPEN_MODAL = 'OPEN_MODAL'
export const CLOSE_MODAL = 'CLOSE_MODAL'
export const CHANGE_NAME_DCB = 'CHANGE_NAME_DCB'
export const DELETE_NAME_DCB = 'DELETE_NAME_DCB'
export const ADD_NAME_DCB = 'ADD_NAME_DCB'
export const EDIT_NAME_DCB = 'EDIT_NAME_DCB'
export const FORM_TOUCHED = 'FORM_TOUCHED'
export const NEW_FORM_NAME_DCB = 'NEW_FORM_NAME_DCB'
export const NAME_DCB_FORM_ERROR = 'NAME_DCB_FORM_ERROR'
export const CHANGE_PAGE = 'CHANGE_PAGE'
export const CHANGE_PER_PAGE = 'CHANGE_PER_PAGE'
export const CHANGE_ORDER_COLUMN = 'CHANGE_ORDER_COLUMN'
export const CHANGE_ORDER_DIRECTION = 'CHANGE_ORDER_DIRECTION'
export const RESET_STATE = 'RESET_STATE'

export const openModal = () => {
  return dispatch => {
    dispatch({ type: OPEN_MODAL })
  }
}

export const handleChangeNameDcb = nameDcb => {
  return dispatch => {
    dispatch({ type: CHANGE_NAME_DCB, nameDcb })
  }
}

const getDuplicateKeyField = errorMessage => {
  const [x, field = ''] = /collection: .* index: (.*)_/.exec(errorMessage) // eslint-disable-line
  return field
}

export const changeOrderColumn = column => {
  return dispatch => {
    dispatch({ type: CHANGE_ORDER_COLUMN, column })
  }
}

export const changeOrderDirection = direction => {
  return dispatch => {
    dispatch({ type: CHANGE_ORDER_DIRECTION, direction })
  }
}

export const handleNameDcbError = (res, dispatch) => {
  const { data: errorMessage = '' } = res
  switch (true) {
    case errorMessage.includes('duplicate key error'):
      dispatch({
        type: FORM_TOUCHED
      })
      dispatch({
        type: NAME_DCB_FORM_ERROR,
        field: getDuplicateKeyField(errorMessage),
        message: `${getDuplicateKeyField(errorMessage)} já cadastrado.`
      })
      return Promise.reject(res)

    default:
      break
  }
}

export const fetchAtcClassification = () => {
  return dispatch => {
    API.namesDcb.getAtcClassifications().then((res = {}) => {
      const { data } = res
      dispatch({ type: FETCH_ATCCLASSIFICATION, atcClassification: data })
    })
  }
}

export const newFormNameDcb = nameDcb => {
  return dispatch => {
    dispatch({ type: NEW_FORM_NAME_DCB })
  }
}

export const setNameDcbFormTouched = nameDcb => {
  return dispatch => {
    dispatch({ type: FORM_TOUCHED })
  }
}

export const closeModal = () => {
  return dispatch => {
    dispatch({ type: CLOSE_MODAL })
  }
}

export const restoreNameDcb = id => {
  return dispatch => {
    dispatch({ type: FETCHING_NAMES_DCB })
    return API.namesDcb
      .restoreNameDcb(id)
      .then(({ data }) => {
        dispatch({ type: EDIT_NAME_DCB, nameDcb: data })
      })
      .catch(err => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data
        dispatch({
          type: FETCH_NAMES_DCB_ERROR,
          err: message || 'Serviço indisponível'
        })
        handleNameDcbError(response, dispatch)
        return Promise.reject(response)
      })
  }
}

export const resetState = () => {
  return dispatch => {
    dispatch({ type: RESET_STATE })
  }
}

export const fetchNamesDcb = options => {
  return dispatch => {
    dispatch({ type: FETCHING_NAMES_DCB })
    return API.namesDcb
      .getNamesDcb(options)
      .then((res = {}) => {
        const { data } = res
        dispatch({
          type: FETCH_NAMES_DCB,
          namesDcb: data.items,
          length: data.length,
          page: data.page,
          order: data.order,
          rowsPerPage: data.rowsPerPage
        })
      })
      .catch(err => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data
        dispatch({
          type: FETCH_NAMES_DCB_ERROR,
          err: message || 'Serviço indisponível'
        })
        return Promise.reject(err)
      })
  }
}

export const handleChangePage = page => {
  return dispatch => {
    dispatch({ type: CHANGE_PAGE, page })
  }
}

export const handleChangePerPage = perPage => {
  return dispatch => {
    dispatch({ type: CHANGE_PER_PAGE, perPage })
  }
}

export const deleteNameDcb = id => {
  return dispatch => {
    dispatch({ type: FETCHING_NAMES_DCB })
    return API.namesDcb
      .deleteNameDcb(id)
      .then(response => {
        const { data = {} } = response
        dispatch({ type: DELETE_NAME_DCB, nameDcb: data })
      })
      .catch(err => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data
        dispatch({
          type: FETCH_NAMES_DCB_ERROR,
          err: message || 'Serviço indisponível'
        })
        return Promise.reject(err)
      })
  }
}

export const addNameDcb = nameDcb => {
  return dispatch => {
    dispatch({ type: FETCHING_NAMES_DCB })
    dispatch({ type: FETCHING_NAME_DCB })
    return API.namesDcb
      .addNameDcb(nameDcb)
      .then(({ data }) => {
        dispatch({ type: ADD_NAME_DCB, nameDcb: data })
      })
      .catch(err => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data
        handleNameDcbError(response, dispatch)
        dispatch({
          type: FETCH_NAMES_DCB_ERROR,
          err: message || 'Serviço indisponível'
        })
        return Promise.reject(err)
      })
  }
}

export const editNameDcb = nameDcb => {
  return dispatch => {
    dispatch({ type: FETCHING_NAMES_DCB })
    dispatch({ type: FETCHING_NAME_DCB })
    return API.namesDcb
      .editNameDcb(nameDcb)
      .then(({ data }) => {
        dispatch({ type: EDIT_NAME_DCB, nameDcb: data })
      })
      .catch(err => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data
        dispatch({
          type: FETCH_NAMES_DCB_ERROR,
          err: message || 'Serviço indisponível'
        })
        handleNameDcbError(response, dispatch)
        return Promise.reject(response)
      })
  }
}

export const fetchNameDcb = id => {
  return dispatch => {
    dispatch({ type: FETCHING_NAME_DCB, clear: true })
    dispatch({ type: OPEN_MODAL })
    return API.namesDcb
      .getNameDcb(id)
      .then(({ data }) => {
        dispatch({ type: FETCH_NAME_DCB, nameDcb: data })
      })
      .catch(err => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data
        dispatch({
          type: FETCH_NAME_DCB_ERROR,
          err: message || 'Serviço indisponível'
        })
        return Promise.reject(err)
      })
  }
}



// WEBPACK FOOTER //
// ./src/actions/namesDcb.js